import getCsrfToken from '../../lib/csrfToken';

async function reissuePassword(account_id: string, email: string) {
  const token_path = '/api/users/csrf_cookie';
  const token_resp = await fetch(token_path);

  let json = { "succeeded": false, "message": "パスワード変更エラーです。" };

  const formData = new FormData();
  formData.append('account_id', account_id);
  formData.append('email', email);

  const headers: HeadersInit = new Headers();
  const token = getCsrfToken();
  if (token !== undefined) {
    headers.set('X-CSRFToken', token);
  }

  const resp = await fetch('/api/users/reissue_pw', {
    method: 'POST',
    headers: headers,
    body: formData
  });

  json = await resp.json();

  if (json.succeeded) {
    json.message = 'パスワードが変更されました。';
  } else {
    json.message = '入力された情報が登録情報と一致しません。';
  }
  return json;
}

export default reissuePassword;